export enum typeInfo
{
	None = 0,
	Email_Address = 1,
	Date = 2,
	URL = 3,
	Phone_Number = 4,
	Number = 5,
	Currency = 6,
	Zip_Code = 7,
	SSN = 8,
	SS_Student_Number = 9,
	CTtest = 10,
	Number_As_Currency = 11,
	Whole_Number = 12,
	Required_Amount = 13,
}
